/**
 * Optimum brand colour palette used internally by the Fee Calculator
 * and on the printable Fee Proposal. Kept exactly as supplied by the
 * source artifact — these colours are intentional for the client-facing
 * proposal document and must not be replaced with Inbox's own palette.
 */
export const C = {
  tealDark: "#153741",
  teal: "#2F5D64",
  tealMid: "#377A80",
  tealSoft: "#6B9FA3",
  orange: "#F2682A",
  text: "#343433",
  muted: "#595959",
  bgSoft: "#F2F2F2",
  border: "#E2E6E7",
  white: "#FFFFFF",
};
